import React from 'react';
import { useTranslation } from 'react-i18next';

function PageHeader({ title, subtitle, children }) {
  return (
    <div className="mb-4 md:mb-6">
      <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4 min-w-0">
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 truncate">{title}</h1>
          {subtitle && (
            <p className="hidden sm:block text-gray-500 text-sm mt-1">{subtitle}</p>
          )}
        </div>
        {children && (
          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto sm:justify-end overflow-visible [&>.dashboard-header-filters]:w-full sm:[&>.dashboard-header-filters]:w-auto">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
